import { useEnvironment } from '@wix/yoshi-flow-editor';
import { ArrowLeftIcon } from '../../icons/arrow-left-icon';
import { ArrowRightIcon } from '../../icons/arrow-right-icon';

export function useArrowIcons() {
  const { isRTL } = useEnvironment();

  const getArrow = (side: 'left' | 'right') => {
    if (isRTL) {
      return side === 'right' ? ArrowLeftIcon : ArrowRightIcon;
    }

    return side === 'right' ? ArrowRightIcon : ArrowLeftIcon;
  };

  return {
    Left: getArrow('left'),
    Right: getArrow('right'),
  };
}
